import { render, staticRenderFns } from "./duplicateremovalsuccessDialog.vue?vue&type=template&id=7627906c&scoped=true&"
import script from "./duplicateremovalsuccessDialog.vue?vue&type=script&lang=js&"
export * from "./duplicateremovalsuccessDialog.vue?vue&type=script&lang=js&"
import style0 from "./duplicateremovalsuccessDialog.vue?vue&type=style&index=0&id=7627906c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7627906c",
  null
  
)

export default component.exports